import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // ホームページかどうかを判定
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: '販売', path: '/sales' },
    { name: '買取', path: '/purchase' },
    { name: 'レンタカー', path: '/rental' },
    { name: '整備', path: '/maintenance' },
    { name: '板金', path: '/bodywork-painting' },
    { name: 'コーティング', path: '/coating' },
  ];

  // ホームページ以外では常に黒背景
  const headerBg = isHomePage 
    ? (isScrolled ? 'bg-black shadow-lg shadow-white/5' : 'bg-black/60 backdrop-blur-sm')
    : 'bg-black shadow-lg shadow-white/5';

  // 常に白テキスト
  const textColor = 'text-white';

  // ボタンスタイル
  const buttonStyle = 'bg-white text-black hover:bg-gray-200';

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBg}`}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Mobile Menu Button - Left (mobile only) */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${textColor}`}
              aria-label="メニュー"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>

            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity lg:mr-0">
              <img
                src="https://static.readdy.ai/image/165569e486d0b590a74ffc9a73595111/4d714d30b9f34eceb87e91f9f7926e8d.png"
                alt="KURUMAYA"
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-medium transition-all duration-300 relative group ${textColor} hover:text-gray-300`}
                >
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </nav>

            {/* Contact Button */}
            <div className="hidden lg:flex items-center gap-4">
              <Link
                to="/contact"
                className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap ${buttonStyle}`}
              >
                <i className="ri-phone-line"></i>
                お問い合わせ
              </Link>
            </div>

            {/* Mobile spacer for centering logo */}
            <div className="w-10 h-10 lg:hidden"></div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/95 backdrop-blur-sm">
            <nav className="flex flex-col items-center justify-center h-full gap-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-xl font-semibold text-white hover:text-gray-300 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <div className="w-full max-w-xs px-6 pt-6 border-t border-white/20">
                <Link
                  to="/contact"
                  className="flex items-center justify-center gap-2 w-full px-6 py-4 bg-white text-black text-base font-semibold rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  お問い合わせ
                </Link>
              </div>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
